import i18n from 'i18next'
import { RouteComponentProps } from 'react-router'

interface Props {
  locale?: string
  path?: string
  hash?: string
  search?: string
}

const getLocalizedPathname = (props: Props) => {
  const locale = props.locale ?? i18n.language
  const path = props.path ?? window.location.pathname
  const hash = props.hash ?? window.location.hash
  const search = props.search ?? window.location.search

  return `/${locale}${path}${hash}${search}`
}

// NOTE: values must be functions in order to preserve window.location sensitive parems (pathname, search)
export const localizedPathnames = {
  // NOTE: creates an href that can used outside of react router context
  homeHref: (history: RouteComponentProps['history']) =>
    history.createHref({ pathname: `/${i18n.language}/` }),

  home: (orgId?: string) =>
    getLocalizedPathname({
      path: '/',
      hash: orgId == null ? undefined : orgIdHash(orgId)
    }),

  application: (appId: string) =>
    getLocalizedPathname({ path: `/application/${appId}` }),

  signing: (appId: string) =>
    getLocalizedPathname({ path: `/application/${appId}/signing` })
}

export const orgIdHash = (orgId: string) => `#a-${orgId}`
